import { ref } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import useProyectosConsejo from "../useOficiosCreacion";
import useDialogVByCPP from "./useDialogVByCCP";

const useDialogOficiosAdjuntos = () => {
  const displayModal = ref(false);

  const { getFichas } = useProyectosConsejo();

  const { barraOficiosCCP } = useDialogVByCPP();

  const store = useStore();

  const adjuntarOficio = async (form) => {
    // const location = window.location.hash.split("/");
    const val = localStorage.getItem("tab");
    const { data: info } = await store.dispatch(
      "oficialia/adjuntarOficio",
      form
    );
    const { status, message } = info;
    if (status === "success") {
      displayModal.value = false;
      await getFichas(val);
      window.dispatchEvent(new Event("cantidadOficiosChanged"));
      await Swal.fire("Archivo Guardado Correctamente", message, "success");
    } else {
      displayModal.value = false;
      await Swal.fire("Error", message, "error");
    }
  };

  const adjuntarOficioModificado = async (form) => {
    const val = localStorage.getItem("tab");
    const { data: info } = await store.dispatch(
      "oficialia/adjuntarOficioModificado",
      form
    );
    const { status, message } = info;
    if (status === "success") {
      displayModal.value = false;
      await getFichas(val);
      window.dispatchEvent(new Event("cantidadOficiosChanged"));
      await Swal.fire("Archivo Guardado Correctamente", message, "success");
    } else {
      displayModal.value = false;
      await Swal.fire("Error", message, "error");
    }
  };
  const contestarAdjunto = async (form) => {
    const val = localStorage.getItem("tab");

    const { data: info } = await store.dispatch(
      "oficialia/contestarAdjunto",
      form
    );
    const { status, folio } = info;
    if (status === "success") {
      displayModal.value = false;
      await getFichas(val);
      await barraOficiosCCP();
      await Swal.fire(
        "Oficio en proceso de contestación, vaya a bandeja de creación de oficios para continuar.",
        ` Folio: ${folio}`,
        "success"
      );
    } else {
      displayModal.value = false;
      await Swal.fire("Error", info.message[0], "error");
    }
  };

  const mostrarAnexos = async (form) => {
    const { data: info } = await store.dispatch(
      "oficialia/mostrarAnexos",
      form
    );
    return info;
  };

  const adjuntarAnexos = async (form) => {
    const val = localStorage.getItem("tab");

    const response = await store.dispatch("oficialia/adjuntarAnexos", form);

    if (!response || !response.data) {
      displayModal.value = false;
      await Swal.fire(
        "Error del servidor",
        "Ocurrió un error inesperado, inténtelo más tarde.",
        "error"
      );
      return;
    }

    const { status, message } = response.data;

    if (status === "success") {
      displayModal.value = false;
      await getFichas(val);
      await Swal.fire("Operación realizada correctamente", message, "success");
    } else {
      displayModal.value = false;
      console.log(message);

      await Swal.fire(
        "Error al realizar la operación",
        message || "Error desconocido",
        "error"
      );
    }
    window.dispatchEvent(new Event("cantidadOficiosChanged"));
  };

  const actualizarAnexos = async (form) => {
    const val = localStorage.getItem("tab");

    const response = await store.dispatch("oficialia/actualizarAnexos", form);

    if (!response || !response.data) {
      displayModal.value = false;
      await Swal.fire(
        "Error del servidor",
        "Ocurrió un error inesperado, inténtelo más tarde.",
        "error"
      );
      return;
    }

    const { status, message } = response.data;

    if (status === "success") {
      displayModal.value = false;
      await getFichas(val);
      await Swal.fire("Operación realizada correctamente", message, "success");
    } else {
      displayModal.value = false;
      console.log(message);

      await Swal.fire(
        "Error al realizar la operación",
        message || "Error desconocido",
        "error"
      );
    }
    window.dispatchEvent(new Event("cantidadOficiosChanged"));
  };

  const descargarArchivoAnexo = async (form) => {
    const info = await store.dispatch("oficialia/descargarArchivoAnexo", form);
    const { status, data } = info;
    if (status === 200) {
      return data;
    } else {
      return data;
    }
  };

  return {
    adjuntarOficio,
    adjuntarOficioModificado,
    contestarAdjunto,
    adjuntarAnexos,
    descargarArchivoAnexo,
    displayModal,
    mostrarAnexos,
    actualizarAnexos,
  };
};

export default useDialogOficiosAdjuntos;
